import { css } from "@emotion/core";
import { breakpoints } from "./breakpoints";
import { fluidProperty, globalFontSize } from "./utilities";
import colors from "./colors";

export const main = "Gotham A, Gotham B, Arial, sans-serif";

export const heading = main;
export const paragraph = main;

export const fontWeight = { standard: '400', bold: '700', extrabold: '800' };

export const lineHeight = '1.1';
export const paragraphLineHeight = '1.5';

// Type Scales
export const minScale = 1.200; //Minor Third
export const maxScale = 1.350;

// Heading Sizes
export const h1range = { min: Math.pow(minScale, 4) + 'rem',
                         max: Math.pow(maxScale, 4)  + 'rem'};
export const h2range = { min: Math.pow(minScale, 3) + 'rem',
                         max: Math.pow(maxScale, 3)  + 'rem'};
export const h3range = { min: Math.pow(minScale, 2) + 'rem',
                         max: Math.pow(maxScale, 2)  + 'rem'};
export const h4range = { min: minScale + 'rem',
                         max: maxScale  + 'rem'};
export const h5range = { min: 1 + 'rem',
                         max: 1 + 'rem'};
export const h6range = { min: (1 / minScale) + 'rem',
                         max: (1 / maxScale) + 'rem'};

/* Values in pixels */
export const fluidText = ($minValue, $maxValue, $minvw = breakpoints.medium, $maxvw = breakpoints.xxlarge ) => `
  ${fluidProperty('font-size', $minValue, $maxValue, $minvw, $maxvw)}
`;

export const h1standard = css`
  font-family: ${main};
  text-transform: uppercase;
  font-style: normal;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 0.5rem;
  margin-top: 0.2rem;
  text-rendering: optimizeLegibility;
  color: ${colors.coreColor1};
  ${fluidText( h1range.min + 'rem', h1range.max + 'rem', breakpoints.medium, breakpoints.xlarge )};
`;

export default fluidText;

let scale = { 1: h1range, 2: h2range, 3: h3range, 4: h4range, 5: h5range, 6: h6range };

export function fontSize(hsize: number) {
  return fluidText( scale[hsize].min + 'rem', scale[hsize].max + 'rem', breakpoints.medium, breakpoints.xlarge );
}